import React, { useState, useEffect, useRef, useContext } from "react"
import { Wrapper } from "./AutoStyles"
import { Currencies } from "@orbital/games-frontend-library"

import { MyContext } from "../../context/createContext"

import {
  helperBetAmount,
  helperNumOfBet,
  helperCashoutAt,
} from "./helpers/helpers"
import {
  onBlurHelperBetAmount,
  onBlurHelperNumOfBets,
  onBlurHelperCashoutAt,
} from "./helpers/onBlurHelpers"
import Section from "./Section"
import Actions from "./Actions"
import { checkisNaN } from "./checkers/checkerFunctions"

export default function Auto({
  handleNotification,
  handleModal,
  modalAnim,
  handleAuto,
  round,
  handleBetOnExplosion,
}: any) {
  const { ctx } = useContext(MyContext)
  const { auth, config, autoConfigs, stake } = ctx
  const { minbet, maxbet, prec } = config
  const { cashoutAt: cashoutAtAut, numOfBets: numOfBetsAut } = autoConfigs

  const min = minbet.toFixed(prec)
  const max = maxbet.toFixed(prec)

  const [betAmount, setbetAmount] = useState(
    Currencies[auth.balance.currency] + (checkisNaN(stake) ? min : stake)
  )
  const [numOfBets, setnumOfBets] = useState(
    checkisNaN(numOfBetsAut) ? "" : numOfBetsAut
  )
  const [cashoutAt, setcashoutAt] = useState(
    Currencies[auth.balance.currency] +
      (checkisNaN(cashoutAtAut) ? (stake * 1.015).toString() : cashoutAtAut)
  )

  const [send, setsend] = useState(false)
  const [infinite, setInfinite] = useState(true)

  useEffect(() => {
    if (send) {
      let stake = betAmount.slice(
        Currencies[auth.balance.currency].length,
        betAmount.length
      )
      let cashout = cashoutAt.slice(
        Currencies[auth.balance.currency].length,
        cashoutAt.length
      )
      handleModal(false)
      handleAuto({ betAmount: stake, numOfBets: numOfBets, cashoutAt: cashout })
    }
    return () => {
      setsend(false)
    }
  }, [
    send,
    betAmount,
    cashoutAt,
    handleAuto,
    handleModal,
    numOfBets,
    auth.balance.currency,
  ])

  const inputEl = useRef<HTMLInputElement | null>(null)

  const startAuto = () => {
    if (inputEl.current) {
      inputEl.current.focus()
    }
    setsend(true)
  }

  const handleBetAmount = (e: any) => {
    helperBetAmount(e, auth.balance.currency, setbetAmount)
  }
  const handleNumOfBet = (e: any) => helperNumOfBet(e, setnumOfBets)
  const handleCashoutAt = (e: any) =>
    helperCashoutAt(e, auth.balance.currency, setcashoutAt)
  const onFocusHandler = () => setInfinite(false)

  const onBlurBetAmount = (e: any) =>
    onBlurHelperBetAmount(
      e,
      max,
      min,
      auth.balance.currency,
      setbetAmount,
      cashoutAt,
      setcashoutAt,
      prec,
      handleNotification
    )
  const onBlurNumOfBets = (e: any) => {
    onBlurHelperNumOfBets(e, setnumOfBets)
    setInfinite(true)
  }
  const onBlurCashoutAt = (e: any) =>
    onBlurHelperCashoutAt(
      e,
      max,
      auth.balance.currency,
      setcashoutAt,
      betAmount,
      prec,
      handleNotification
    )

  useEffect(() => {
    onBlurCashoutAt(cashoutAt)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stake])

  return (
    <Wrapper anim={modalAnim}>
      <Section
        name="BET AMOUNT"
        value={betAmount}
        handler={handleBetAmount}
        onBlur={onBlurBetAmount}
        placeHolder={min}
        currency={auth.balance.currency}
      />
      <Section
        name="NUMBER OF BETS"
        value={numOfBets}
        handler={handleNumOfBet}
        onBlur={onBlurNumOfBets}
        placeHolder
        infinite={infinite}
        maxLength={4}
        onFocus={onFocusHandler}
      />
      <Section
        name="CASHOUT AT"
        value={cashoutAt}
        handler={handleCashoutAt}
        onBlur={onBlurCashoutAt}
        currency={auth.balance.currency}
      />
      <Actions
        handleModal={handleModal}
        startAuto={startAuto}
        round={round}
        handleBetOnExplosion={handleBetOnExplosion}
      />
      <input
        style={{ width: 0, height: 0, border: 0, pointerEvents: "none" }}
        ref={inputEl}
      />
    </Wrapper>
  )
}
